module.exports = __webpack_public_path__ + "img/15.c549f854.png";